export default __webpack_public_path__ + "static/93922-951c7101eea5dc07c4f70fa84bde028d.jpg";